import React, { useEffect, useState } from "react";
import LoginForm from "./loginForm";
import NavBar from "../general/navbar"
import getFirebase from "../../utils/firebase.js";
import Footer from "../general/footer";

const Main = () => {
  useEffect(() => {
    const firebase = getFirebase();
  }, []);

  return (
    <div className="bg-[#27004F] min-h-screen">
      <NavBar/>      
      <LoginForm/>
      <Footer/>
    </div>
  );
}

export default Main
